// store.js
//dev
//export const dataPromise = fetch('https://www.wanada.lcprojects.com.au/services/?token=005182f96b3e68d0acc30fbccfc633d5').then(value => value.json());

//prod
export const dataPromise = fetch('https://wanada.org.au/services/?token=005182f96b3e68d0acc30fbccfc633d5').then(value => value.json());


export const catPromise = fetch('https://wanada.org.au/wp-json/acf/v3/options/options').then(value => value.json());
